import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CurrentUserService } from '../../core/services/user/current-user.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../core/services/language.service';

declare var KTMenu: any;

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule, TranslateModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  constructor(
    private currentUserService: CurrentUserService,
    private translate: TranslateService,
    private languageService: LanguageService
  ) {
    const userLang = this.languageService.getLanguage() || 'en';
    this.translate.use(userLang);
  }

  currentUser: any = null;

  ngAfterViewInit() {
    this.initializeMenu();
  }

  ngOnInit() {
    this.currentUser = this.currentUserService.GetSession();
  }

  initializeMenu() {
    const menuItems = document.querySelectorAll(
      '[data-kt-menu-trigger="click"]'
    );
    menuItems.forEach((item) => {
      const menuLink = item.querySelector('.menu-link') as HTMLElement;
      const menuSub = item.querySelector('.menu-sub') as HTMLElement;

      if (menuLink) {
        menuLink.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();
          if (menuSub) {
            if (menuSub.style.display === 'block') {
              menuSub.style.display = 'none';
            } else {
              const openMenus = document.querySelectorAll('.menu-sub');
              openMenus.forEach((openMenu) => {
                (openMenu as HTMLElement).style.display = 'none';
              });
              menuSub.style.display = 'block';
            }
          }
        });
      }

      if (menuSub) {
        const subMenuLinks = menuSub.querySelectorAll('.menu-item a');
        subMenuLinks.forEach((subMenuLink) => {
          subMenuLink.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        });
      }
    });
  }

  backToDerm() {
    if (typeof window !== 'undefined') {
      window.location.href = `${environment.apiLocations.derm}/dashboard`;
    }
  }
}
